<template>
  <section role="modal">
    <div
      class="modal fade"
      id="explicacaoModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="explicacaoModalLabel"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title" id="explicacaoModalLabel">
              Fluxo do Agendamento de Férias
            </h4>
          </div>
          <div class="modal-body">
            <div class="row row-field" style="padding-bottom: 15px;">
              <div class="col-md-12 col-sm-12">
                <ol>
                  <li>
                    Você deverá escolher, no calendário, uma data válida para o seu
                    início de férias e salvá-la.
                  </li>
                  <li>
                    A data salva não poderá ser alterada.
                  </li>
                  <li>
                    Essa data proposta será analisada pelo seu chefe direto ou por um
                    responsável, que poderá aprová-la ou não.
                  </li>
                  <li>
                    Caso a data escolhida não seja aprovada, você receberá um email
                    notificando a reprovação, e o seu agendamento de férias ficará
                    aberto para que você possa escolher uma nova data.
                  </li>
                </ol>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <botao
              estilo="cheio-verde"
              rotulo="Entendi"
              icone="ok-modal"
              dismiss="modal"
            ></botao>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Botao from "@/components/botao";

export default {
  name: "ExplicacaoModal",

  components: {
    Botao,
  },
};
</script>

<style scoped>
ol {
  padding-inline-start: 20px;
}
li {
  padding-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// explicacao-modal.vue?8b23aec8